import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { HelpCircle, CheckCircle2, MessageSquare } from "lucide-react";

export const Route = createFileRoute("/questions")({
  head: () => ({ meta: [{ title: "Xamseen — Questions & Solutions" }] }),
  component: QuestionsPage,
});

function QuestionsPage() {
  const [items, setItems] = useState<any[]>([]);
  useEffect(() => {
    supabase.from("posts").select("id,title,content,category,accepted_solution_id,comment_count,upvotes,created_at,author:profiles!posts_author_profile_fkey(username,full_name)")
      .eq("post_type", "question").order("created_at", { ascending: false }).limit(50)
      .then(({ data }) => setItems(data ?? []));
  }, []);

  return (
    <AppShell>
      <div className="mx-auto max-w-3xl space-y-6">
        <header>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Questions & Solutions</h1>
          <p className="text-muted-foreground">Ask the community, find accepted answers from solutionists.</p>
        </header>
        {items.length === 0 ? (
          <Card className="p-12 text-center">
            <HelpCircle className="mx-auto mb-3 h-10 w-10 text-muted-foreground" />
            <p className="font-medium">No questions yet</p>
          </Card>
        ) : (
          <div className="space-y-3">
            {items.map((q: any) => (
              <Link key={q.id} to="/posts/$id" params={{ id: q.id }}>
                <Card className="p-5 hover:bg-accent/40">
                  <div className="mb-2 flex items-center gap-2">
                    {q.accepted_solution_id && <Badge className="bg-secondary text-secondary-foreground gap-1"><CheckCircle2 className="h-3 w-3" />Solved</Badge>}
                    <Badge variant="outline" className="capitalize">{q.category}</Badge>
                  </div>
                  <h3 className="font-semibold">{q.title}</h3>
                  <p className="mt-1 text-sm text-muted-foreground line-clamp-2">{q.content}</p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-muted-foreground">
                    <span>@{q.author?.username}</span>
                    <span className="flex items-center gap-1"><MessageSquare className="h-3 w-3" />{q.comment_count}</span>
                    <span>↑ {q.upvotes}</span>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
